import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import $ from "jquery";

export class OMSTabBox extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,

    value: PropTypes.array,
    setActiveTabId: PropTypes.func,
  };

  static defaultProps = {
    id: "",
    value: null,
  };

  state = {
    moreIndex: -1,
    selectedIndex: 0,
  };

  updateDimensions = () => {
    var tabs = $("#tabs");
    //console.log("tabs",tabs);
    //var tabs=undefined;
    if (tabs == undefined) {
      alert("catch");
    } else {
      var tabsHeight = tabs.innerHeight();
      var tabsWidth = tabs.innerWidth();
      var maxChildWidth = 0;

      var children = tabs.children("li");
      for (var i = 0; i < children.length; i++) {
        if (children[i].id != "lastTab") {
          var W = children[i].clientWidth;
          if (W > maxChildWidth) maxChildWidth = W;
        }
      }

      var moreIndex = -1;
      var directCount = Math.floor(tabsWidth / maxChildWidth);
      var totalCount = this.props.value.length;
      if (totalCount > directCount) moreIndex = directCount - 1;

      this.setState({ moreIndex: moreIndex });
      //console.log('H:' + tabsHeight + ' W:' + tabsWidth + ' CW:' + maxChildWidth + ' DC: ' + directCount + ' Index: ' + moreIndex);
      //console.log("H:" + tabsHeight + " W:" + tabsWidth + " CW:" + maxChildWidth + " DC: " + directCount + " Index: " + moreIndex);
    }
  };
  moreItemClick = (index) => {
    this.setState({ selectedIndex: index });
    this.props.setActiveTabId(this.props.value[index].link.replace("#", ""));
  };
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  render() {
    //console.log(this.props.id, this.props.value);
    var self = this;
    var tabHtml = null;
    var moreHtml = null;
    if (self.state.moreIndex != -1) {
      moreHtml = self.props.value.map(function (item, index) {
        return index >= self.state.moreIndex ? (
          <li key={item.title} className={index == self.state.selectedIndex ? "active" : ""} onClick={() => self.moreItemClick(index)}>
            <a data-index={index} data-toggle="tab" href={item.link} aria-expanded={index == self.state.selectedIndex}>
              {item.title}
            </a>
          </li>
        ) : null;
      });
    }
    tabHtml = self.props.value.map(function (item, index) {
      return self.state.moreIndex == -1 || index < self.state.moreIndex ? (
        <li key={item.title} className={index == self.state.selectedIndex ? "active" : ""} onClick={() => self.moreItemClick(index)}>
          <a data-index={index} data-toggle="tab" href={item.link} aria-expanded={index == self.state.selectedIndex}>
            {item.title}
          </a>
        </li>
      ) : null;
    });
    //console.log(moreHtml, tabHtml);
    return (
      <ul id="tabs" className="nav nav-tabs">
        {tabHtml}
        {this.state.moreIndex == -1 ? null : (
          <li id="lastTab" className={this.state.moreIndex <= this.state.selectedIndex ? "active" : ""}>
            <a className="btn dropdown-toggle" data-toggle="dropdown" href="#">
              More <span className="caret"></span>
            </a>
            <ul className="dropdown-menu" >
              {moreHtml}
            </ul>
          </li>
        )}
      </ul>
    );
  }
}
